export default {
  namespaced: true,
  state: {
    loaded: false, // do not show stats until whitelist is processed
    compareMode: false,
    filters: {
      before: '',
      after: '',
      prisonId: '',
      prisonGroupId: '',
      prisonIds: [],
    },
    compareFilters: {
      before: '',
      after: '',
      prisonId: '',
      prisonGroupId: '',
      compare: true, // used for identifying as a compare comp
    },
    prisons: [],
    prisonGroups: [],
  },
  getters: {},
  mutations: {
    SET_FILTERS(state, item) {
      state.filters = item;
    },
    SET_FILTER_ITEM(state, item) {
      state.filters[item.name] = item.value;
    },
    SET_COMPARE_FILTER_ITEM(state, item) {
      state.compareFilters[item.name] = item.value;
    },
    SET_PRISONS(state, value) {
      state.prisons = value;
    },
    SET_PRISON_GROUPS(state, value) {
      state.prisonGroups = value;
    },
    SET_COMPARE_MODE(state, value) {
      state.compareMode = value;
    },
    SET_LOADED(state, value) {
      state.loaded = value;
    },
  },
  actions: {

  },
};
